module.exports = __webpack_public_path__ + "img/wind-01.38986dfb.jpg";